export var ViewType;
(function (ViewType) {
    ViewType["DesktopSmall"] = "desktopSmall";
    ViewType["DesktopLarge"] = "desktopLarge";
    ViewType["MobileSmall"] = "mobileSmall";
    ViewType["MobileLarge"] = "mobileLarge";
})(ViewType || (ViewType = {}));
